import { Reveal, Overline } from "./Reveal";
import { MANIFESTO, IMAGES } from "../../lib/content";
import { useLang } from "../../lib/i18n";

export const Manifesto = () => {
  const { lang, tr } = useLang();
  return (
    <section
      id="manifesto"
      data-testid="manifesto-section"
      className="relative bg-ad-black py-24 md:py-40"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-10">
          {/* Intro */}
          <div className="lg:col-span-5">
            <Reveal>
              <Overline>{tr("Il Nostro Credo", "Our Credo")}</Overline>
              <h2 className="mt-6 font-serif-display font-light text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-white">
                {tr("Non vendiamo abiti.", "We don't sell dresses.")}
                <span className="block italic text-gold mt-2">
                  {tr("Custodiamo emozioni.", "We safeguard emotions.")}
                </span>
              </h2>
              <p className="mt-8 font-sans-ui font-light text-white/70 leading-relaxed max-w-md">
                {tr(
                  "Da Atelier Divine ogni incontro è dedicato a te. Nessun acquisto affrettato: solo tempo, ascolto e sartorialità autentica per rendere indimenticabile il tuo giorno.",
                  "At Atelier Divine every meeting is dedicated to you. No hurried purchases: only time, attentive listening and authentic tailoring to make your day unforgettable."
                )}
              </p>
              <div className="hairline w-24 mt-10" />
            </Reveal>

            <Reveal delay={0.15} className="mt-12 hidden lg:block">
              <div className="relative overflow-hidden">
                <img
                  src={IMAGES.lace}
                  alt="Dettaglio sartoriale"
                  className="w-full h-[360px] object-cover grayscale hover:grayscale-0 transition-[filter] duration-1000"
                />
                <div className="absolute inset-0 ring-1 ring-inset ring-white/10" />
              </div>
            </Reveal>
          </div>

          {/* Numbered chapters */}
          <div className="lg:col-span-6 lg:col-start-7 flex flex-col">
            {MANIFESTO.map((c, i) => (
              <Reveal
                key={c.n}
                delay={i * 0.1}
                data-testid={`manifesto-chapter-${c.n}`}
                className="border-t border-white/12 py-9 md:py-11 group"
              >
                <div className="flex items-start gap-6 md:gap-10">
                  <span className="font-serif-display text-3xl md:text-4xl text-gold/70 leading-none pt-1 tabular-nums group-hover:text-gold transition-colors duration-500">
                    {c.n}
                  </span>
                  <div>
                    <h3 className="font-serif-display text-2xl md:text-3xl text-white font-light">
                      {lang === "it" ? c.title : c.titleEn}
                    </h3>
                    <p className="mt-4 font-sans-ui font-light text-white/65 leading-relaxed max-w-lg">
                      {lang === "it" ? c.body : c.bodyEn}
                    </p>
                  </div>
                </div>
              </Reveal>
            ))}
            <div className="border-t border-white/12" />
          </div>
        </div>
      </div>
    </section>
  );
};
